<ng-container *ngrxLet="{ prismLabelsTemplate: prismLabelsTemplate$ } as vm">
    <dtm-map-html-cesium-component
        *ngFor="let label of labels$ | ngrxPush; trackBy: trackByEntityId"
        [coordinates]="label.position"
        [shouldHideOccluded]="false"
        [shouldHideOutOfView]="false"
    >
        <ng-container *ngIf="vm.prismLabelsTemplate; else simpleLabelsTemplate">
            <ng-container *ngTemplateOutlet="vm.prismLabelsTemplate; context: { $implicit: label }"></ng-container>
        </ng-container>
        <ng-template #simpleLabelsTemplate>
            <span class="default-label">{{ label.text }}</span>
        </ng-template>
    </dtm-map-html-cesium-component>
</ng-container>
